import React, { FC, useState } from "react";
import Nav from "componentsTemplate/Nav/Nav";
import NavItem from "componentsTemplate/NavItem/NavItem";
import Button from "../Button/Button";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import Heading from "components/heading/Heading";

export interface HeaderFilterProps {
  tabs?: string[];
  heading: string;
  subHeading?: string;
}

const HeaderFilter: FC<HeaderFilterProps> = ({
  tabs = ["Todos", "Dicas", "Conexões", "Eventos"],
  heading = "🎈 Latest Articles",
  subHeading = "Over 1,000 articles",
}) => {
  const [tabActive, setTabActive] = useState<string>(tabs[0]);

  const handleClickTab = (item: string) => {
    if (item === tabActive) {
      return;
    }
    setTabActive(item);
  };

  return (
    <div className="flex flex-col mb-8 relative">
      <Heading desc={subHeading}>{heading}</Heading>
      {/* <div className="flex justify-between">
        <Nav
          className="sm:space-x-2"
          containerClassName="relative flex w-full overflow-x-auto text-sm md:text-base"
        >
          {tabs.map((item, index) => (
            <NavItem
              key={index}
              isActive={tabActive === item}
              onClick={() => handleClickTab(item)}
            >
              {item}
            </NavItem>
          ))}
        </Nav>
        <Button className="!hidden md:!flex" pattern="white" sizeClass="px-6">
          <span>Ver Todos</span>
          <ArrowRightIcon className="w-6 h-6 ml-3" />
        </Button>
      </div> */}
    </div>
  );
};

export default HeaderFilter;
